import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import TextareaAutosize from 'react-autosize-textarea';
import DatePicker from 'react-datepicker';
import DocumentUpload from '../DocumentUpload';
import RateInput from '../common/RateInput';
import { formatCurrency } from '../../numberUtils';
import { formatDateForApi } from '../../dateUtils';
var EditLineItem = /*#__PURE__*/function (_Component) {
  function EditLineItem(props) {
    var _this;
    _classCallCheck(this, EditLineItem);
    _this = _callSuper(this, EditLineItem, [props]);
    _this.state = {
      date: moment(props.date).toDate(),
      description: props.description,
      optional_id: props.optional_id,
      hours: props.hours,
      minutes: props.minutes,
      total: props.total,
      maxDate: moment(props.endDate).toDate(),
      minDate: moment(props.startDate).toDate()
    };
    _this.handleInputChange = _this.handleInputChange.bind(_this);
    _this.handleCurrencyInputChange = _this.handleCurrencyInputChange.bind(_this);
    _this.handleOnBlur = _this.handleOnBlur.bind(_this);
    return _this;
  }
  _inherits(EditLineItem, _Component);
  return _createClass(EditLineItem, [{
    key: "handleInputChange",
    value: function handleInputChange(key, value) {
      var rate = this.props.rate;
      if (key === 'hours' || key === 'minutes') {
        var val = parseInt(value, 10) || 0;
        this.setState(_defineProperty({}, key, val));
        var total;
        var _this$state = this.state,
          hours = _this$state.hours,
          minutes = _this$state.minutes;
        if (key === 'hours') {
          total = (val + minutes / 60) * rate;
        } else {
          total = (hours + val / 60) * rate;
        }
        this.setState({
          total: total
        });
      } else {
        this.setState(_defineProperty({}, key, value));
      }
    }
  }, {
    key: "handleOnBlur",
    value: function handleOnBlur(key) {
      var _this$props = this.props,
        id = _this$props.id,
        updateLineItem = _this$props.updateLineItem;
      var total = this.state.total;
      var value = this.state[key];
      if (key === 'hours' || key === 'minutes') {
        updateLineItem(id, _defineProperty(_defineProperty({}, key, value), "total", total));
      } else if (key === 'total') {
        updateLineItem(id, {
          total: +value
        });
      } else if (key === 'date') {
        // value is a raw Date (react-datepicker, local midnight) — send a date-only string so
        // JSON.stringify never gets the chance to convert it to UTC and shift the day. See
        // formatDateForApi.
        updateLineItem(id, {
          date: formatDateForApi(value)
        });
      } else {
        updateLineItem(id, _defineProperty({}, key, value));
      }
    }
  }, {
    key: "handleCurrencyInputChange",
    value: function handleCurrencyInputChange(value) {
      this.setState({
        total: +value
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;
      var _this$props2 = this.props,
        index = _this$props2.index,
        invoiceId = _this$props2.invoiceId,
        id = _this$props2.id,
        hasDuration = _this$props2.hasDuration,
        viewDocumentUrl = _this$props2.viewDocumentUrl,
        category = _this$props2.category,
        deleteLineItem = _this$props2.deleteLineItem,
        document = _this$props2.document,
        uploadFile = _this$props2.uploadFile,
        csrfToken = _this$props2.csrfToken,
        status = _this$props2.status,
        feedback = _this$props2.feedback;
      var _this$state2 = this.state,
        date = _this$state2.date,
        minDate = _this$state2.minDate,
        maxDate = _this$state2.maxDate,
        description = _this$state2.description,
        hours = _this$state2.hours,
        minutes = _this$state2.minutes,
        total = _this$state2.total,
        optional_id = _this$state2.optional_id;
      return /*#__PURE__*/React.createElement("div", {
        className: "line-item line-item-edit ".concat(index % 2 === 1 && 'even-row')
      }, /*#__PURE__*/React.createElement("div", {
        className: "g-row--always"
      }, feedback && /*#__PURE__*/React.createElement("i", {
        className: "edits-requested-indicator fa fa-circle"
      }), /*#__PURE__*/React.createElement("div", {
        className: "date ".concat(feedback ? 'with-feedback' : '', " g-row g-row--start-between")
      }, /*#__PURE__*/React.createElement("label", {
        className: "g-row--always",
        htmlFor: "calendar-".concat(id)
      }, /*#__PURE__*/React.createElement(DatePicker, {
        selected: date,
        onChange: function onChange(val) {
          return _this2.handleInputChange('date', val);
        },
        onBlur: function onBlur() {
          return _this2.handleOnBlur('date');
        },
        minDate: minDate,
        maxDate: maxDate,
        allowSameDay: true,
        className: "form-control",
        id: "calendar-".concat(id),
        value: date,
        dateFormat: "MM/dd/yyyy",
        popperPlacement: "top-end"
      }), /*#__PURE__*/React.createElement("i", {
        className: "fa fa-calendar"
      }))), /*#__PURE__*/React.createElement("div", {
        className: "optional-id"
      }, /*#__PURE__*/React.createElement("input", {
        type: "text",
        className: "form-control optional-id",
        name: "optional-id",
        id: "optional-id",
        value: optional_id,
        onChange: function onChange(e) {
          return _this2.handleInputChange('optional_id', e.target.value);
        },
        onBlur: function onBlur() {
          return _this2.handleOnBlur('optional_id');
        }
      })), /*#__PURE__*/React.createElement("div", {
        className: "description"
      }, /*#__PURE__*/React.createElement(TextareaAutosize, {
        name: "description",
        className: "fs-hide description",
        placeholder: "Describe what you worked on here...",
        value: description,
        onChange: function onChange(e) {
          return _this2.handleInputChange('description', e.target.value);
        },
        onBlur: function onBlur() {
          return _this2.handleOnBlur('description');
        },
        rows: 1
      })), hasDuration && /*#__PURE__*/React.createElement("div", {
        className: "hours-and-minutes g-row--always g-row--start"
      }, /*#__PURE__*/React.createElement("input", {
        type: "number",
        id: "hours-".concat(id),
        className: "form-control hours",
        min: "0",
        value: hours !== 0 ? hours : '',
        onChange: function onChange(e) {
          return _this2.handleInputChange('hours', parseInt(e.target.value, 10));
        },
        onBlur: function onBlur() {
          return _this2.handleOnBlur('hours');
        }
      }), /*#__PURE__*/React.createElement("div", {
        className: "body-text-2 mx-2 mt-2"
      }, "h"), /*#__PURE__*/React.createElement("input", {
        type: "number",
        id: "minutes-".concat(id),
        className: "form-control minutes",
        min: "0",
        max: "60",
        value: minutes !== 0 ? minutes : '',
        onChange: function onChange(e) {
          return _this2.handleInputChange('minutes', e.target.value, 10);
        },
        onBlur: function onBlur() {
          return _this2.handleOnBlur('minutes');
        }
      }), /*#__PURE__*/React.createElement("div", {
        className: "body-text-2 ms-2 mt-2"
      }, "min")), hasDuration ? /*#__PURE__*/React.createElement("div", {
        className: "total"
      }, formatCurrency(total)) : /*#__PURE__*/React.createElement("div", {
        className: "total"
      }, /*#__PURE__*/React.createElement(RateInput, {
        className: "form-control total",
        value: total,
        onAnswerChange: function onAnswerChange(val) {
          return _this2.handleCurrencyInputChange(val);
        },
        onBlur: function onBlur() {
          return _this2.handleOnBlur('total');
        }
      })), !hasDuration && /*#__PURE__*/React.createElement("div", {
        className: "file"
      }, /*#__PURE__*/React.createElement(DocumentUpload, {
        prompt: "Add File",
        viewDocumentUrl: viewDocumentUrl,
        csrfToken: csrfToken,
        documentType: "invoice",
        location: "Invoicing",
        uploadDocumentUrl: "/invoices/".concat(invoiceId, "/line_items/upload_file?id=").concat(id),
        handleAfterUpload: function handleAfterUpload(doc) {
          return uploadFile(id, doc);
        },
        document: document
      })), /*#__PURE__*/React.createElement("div", {
        className: "actions"
      }, /*#__PURE__*/React.createElement("button", {
        className: "delete",
        onClick: function onClick() {
          return deleteLineItem(id, category);
        }
      }, /*#__PURE__*/React.createElement("i", {
        className: "fa fa-trash-alt mt-6"
      })))), status === 'edits_requested' && feedback && /*#__PURE__*/React.createElement("div", {
        className: "line-item-feedback"
      }, /*#__PURE__*/React.createElement("div", {
        className: "body-text-2 medium-weight pb-8"
      }, "Comments"), /*#__PURE__*/React.createElement("div", {
        className: "body-text-2"
      }, feedback)));
    }
  }]);
}(Component);
EditLineItem.propTypes = {
  id: PropTypes.number,
  date: PropTypes.string.isRequired,
  description: PropTypes.string.isRequired,
  hours: PropTypes.number.isRequired,
  minutes: PropTypes.number.isRequired,
  updateLineItem: PropTypes.func.isRequired,
  hasDuration: PropTypes.bool,
  rate: PropTypes.number,
  invoiceId: PropTypes.string.isRequired,
  index: PropTypes.number.isRequired,
  viewDocumentUrl: PropTypes.string.isRequired,
  category: PropTypes.string.isRequired,
  deleteLineItem: PropTypes.func.isRequired,
  total: PropTypes.number.isRequired,
  document: PropTypes.shape({}),
  uploadFile: PropTypes.func.isRequired,
  startDate: PropTypes.string.isRequired,
  endDate: PropTypes.string.isRequired,
  csrfToken: PropTypes.string,
  status: PropTypes.string.isRequired,
  feedback: PropTypes.string,
  optional_id: PropTypes.string
};
EditLineItem.defaultProps = {
  id: null,
  hasDuration: false,
  rate: null,
  csrfToken: '',
  document: {},
  feedback: '',
  optional_id: ''
};
export default EditLineItem;